import { render, staticRenderFns } from "./FlightLazyLoad.vue?vue&type=template&id=2a15024e&scoped=true"
import script from "./FlightLazyLoad.vue?vue&type=script&lang=js"
export * from "./FlightLazyLoad.vue?vue&type=script&lang=js"
import style0 from "./FlightLazyLoad.vue?vue&type=style&index=0&id=2a15024e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15024e",
  null
  
)

export default component.exports